var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetsecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 71,
    viewBox: "0 0 104 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5661,
    cy: 35.1942,
    r: 34.1931,
    fill: "#F8B400",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4141 70C69.4679 70 84.9141 54.5538 84.9141 35.5C84.9141 16.4462 69.4679 1 50.4141 1C31.3602 1 15.9141 16.4462 15.9141 35.5C15.9141 54.5538 31.3602 70 50.4141 70Z",
    stroke: "#005555",
    strokeWidth: 1.79514,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2673 14.4568C59.6567 14.4568 64.9177 19.1241 64.9177 26.277C64.9177 35.5584 58.7107 38.8067 49.8444 38.8694L49.7238 46.4374H47.4794L47.3008 36.8616H48.4833C55.3998 36.8616 62.3741 35.4426 62.3741 26.2818C62.3741 20.3693 58.2377 16.706 52.3253 16.706C46.4128 16.706 42.3971 20.3114 42.3971 25.8668H39.8535C39.8535 18.7138 45.1723 14.4568 52.2673 14.4568ZM48.604 56.5441C47.3057 56.5441 46.2969 55.5981 46.2969 54.2371C46.2969 52.876 47.3008 51.93 48.604 51.93C49.9072 51.93 50.8483 52.876 50.8483 54.2371C50.8483 55.5981 49.8444 56.5441 48.604 56.5441Z",
    fill: "#005555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0664 35.5004H103.163",
    stroke: "#005555",
    strokeWidth: 1.79514,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0664 30.4427L98.115 25.2686",
    stroke: "#005555",
    strokeWidth: 1.79514,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.115 46.607L93.0664 41.433",
    stroke: "#005555",
    strokeWidth: 1.79514,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0923 35.5004H0",
    stroke: "#005555",
    strokeWidth: 1.79514,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0925 30.4427L5.04883 25.2686",
    stroke: "#005555",
    strokeWidth: 1.79514,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04883 46.607L10.0925 41.433",
    stroke: "#005555",
    strokeWidth: 1.79514,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetsecurity);
export default __webpack_public_path__ + "static/media/setsecurity.9d4408baac7627831ae5cac00267d9c5.svg";
export { ForwardRef as ReactComponent };